var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h4',{staticStyle:{"line-height":"1.5"}},[_vm._v("Office Tech \\ "),_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.reOpenStore}},[_vm._v("N-TECH")])]),_c('iframe',{staticClass:"iframe-wrapper",attrs:{"src":"/marketplace-90780259.html","frameborder":"0","id":"marketplace-90780259"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }